import {
  getCodeCultures,
  getCodeListWithCulture,
  getVendorLoginInfo,
  loginVendor,
  updateVendorPw,
  getRegion,
  getArea,
  getFactory,
  getNoticeList,
  getNoticeIsActive,
  getEnterReason,
  getRegionAreaByFactory,
  mailService,
  getReserveTable,
  getReserveInfo,
  getVendorInfo,
  getCarColor,
  getCartype,
  updateReserveInfo,
  getReserveTableCountForVendor,
  getReserveTableCountForVendorSearch,
  getReserveTableForVendor,
	exportReserveTableForVendor,
  getVendorReleaseTable,
  getReleaseInfo,
  getSignTable,
  getSoListBindingWithReserveData,
  getReleaseTableWithSign,
  getCompanyNameByPlantCode,
  hasAgreedPrivacy,
  updateAgreePrivacy,
  getReserveQRCode
} from "@/utils/api_construction.js"

export var api = {
  apiMailService: function (data) {
    return mailService(data)
  },
  apiGetVendorLoginInfo:function(){
    return getVendorLoginInfo()
  },
  apiLoginVendor: function (data) {
    return loginVendor(data)
  },
  apiUpdateVendorPw: function (data) {
    return updateVendorPw(data)
  },
  /***************-BASE-***************/
  apiGetCodeCultures: function () {
    return getCodeCultures()
  },
  apiGetCodeListWithCulture: function (data) {
    return getCodeListWithCulture(data)
  },
  apiGetRegion: function (data) {
    return getRegion(data)
  },
  apiGetArea: function (data) {
    return getArea(data)
  },
  apiGetFactory: function (data) {
    return getFactory(data)
  },
  apiGetEnterReason: function () {
    return getEnterReason()
  },
  apiGetRegionAreaByFactory: function (data) {
    return getRegionAreaByFactory(data)
  },
  apiGetCarColor: function () {
    return getCarColor()
  },
  apiGetCartype: function () {
    return getCartype()
  },
  /***************-BASE-***************/
  apiGetVendorInfo: function (data) {
    return getVendorInfo(data)
  },
  /***************-RESERVE-***************/
  apiNGetNoticeIsActive: function () {
    return getNoticeIsActive()
  },
  apiGetNoticeList: function () {
    return getNoticeList()
  },
  apiGetReserveTable: function (data) {
    return getReserveTable(data)
  },
  apiGetReserveInfo: function (data) {
    return getReserveInfo(data)
  },
  apiUpdateReserveInfo: function (data) {
    return updateReserveInfo(data)
  },
  /***************-VENDOR-***************/
  apiGetReserveTableCountForVendor: function (data) {
    return getReserveTableCountForVendor(data)
  },
  apiGetReserveTableCountForVendorSearch: function (data) {
    return getReserveTableCountForVendorSearch(data)
  },
  apiGetReserveTableForVendor: function (data) {
    return getReserveTableForVendor(data)
  },
	apiExportReserveTableForVendor: function (data) {
    return exportReserveTableForVendor(data)
  },
  apiGetVendorReleaseTable: function (data) {
    return getVendorReleaseTable(data)
  },
  apiUpdateRelease: function (data) {
    return updateRelease(data)
  },
  apiGetReleaseInfo: function (data) {
    return getReleaseInfo(data)
  },
  apiGetSignTable: function (data) {
    return getSignTable(data)
  },
  apiGetSoListBindingWithReserveData: function (reserveID, oaCode) {
    return getSoListBindingWithReserveData(reserveID, oaCode)
  },
  apiGetReleaseTableWithSign: function (data) {
    return getReleaseTableWithSign(data)
  },
  apiGetCompanyNameByPlantCode: function (data) {
    return getCompanyNameByPlantCode(data)
  },
  apiHasAgreedPrivacy: function () {
    return hasAgreedPrivacy()
  },
  apiUpdateAgreePrivacy: function () {
    return updateAgreePrivacy()
  },
  apiGetReserveQRCode: function (reserveNo, id) {
    return getReserveQRCode(reserveNo, id)
  }
}
